import { TemplatePage } from './types';

const liveStreamBlackStarTheme: TemplatePage = {
  header: {
    color: '#E1E1E1',
    icon: 'images/video-templates/black_star_theme.jpg',
    title: 'Live Stream Templates — Black Star Theme',
    title_meta: '10+ Free Live Stream Overlay Templates — Black Star Theme',
    description_meta:
      'Make your live streams look irresistible with Wave.video’s black-star-themed templates. ' +
      'Get a package of free transition screens, overlays, and frames.',
    description:
      'Wow your live streams’ fans with our black-star-themed templates. Create highly professional ' +
      'visuals with no design skills. Get a set of pre-designed overlays, transition screens, and frames ' +
      'for multistreaming services like' +
      ` <a href=https://wave.video/live-streaming/streaming-software class="blackLink">Wave.video Live Streaming Studio</a>.`
  },
  footer: {
    category: 'Live streaming black star theme',
    description:
      'With Wave.video’s themed collections of editable templates, you will impress the attendees of your ' +
      'online conference with no design team! Pick a set of templates that includes thumbnails, countdown, ' +
      'intro & outros, overlays, transition screens, and promo videos and make your event shine. All you need ' +
      'to do is to change the color palette, titles, dates, and names - and you’re all set! Make a conference ' +
      'that everyone will be talking about for a long time. '
  },
  content: [
    {
      type: 'templates',
      title: 'Live streaming black star theme',
      search: { name: 'BlackStarTheme', tags: 'BlackStarTheme' }
    },
    { type: 'calendar' }
  ]
};

export default liveStreamBlackStarTheme;
